/************************************************************************
 ** IBM Confidential
 **
 ** IBM Business Analytics: Rapidly Adaptive Visualization Engine
 **
 ** (C) Copyright IBM Corp. 2022
 **
 ** The source code for this program is not published or otherwise divested of its trade secrets, 
 ** irrespective of what has been deposited with the U.S. Copyright Office.
 ************************************************************************/
// GENERATED
import PhysicalObjectType from './PhysicalObjectType';
import MoserObject from './MoserObject';
//@import com/ibm/bi/platform/moser/common/generated/metadata/PhysicalObjectType (loadtime) // superclass
//@import com/ibm/bi/platform/moser/common/generated/metadata/MoserObject (static) // fromJSONHelper

/**
 * <p>Java class for anonymous complex type. <p>The following schema fragment specifies the expected content contained within this class. <pre> &lt;complexType&gt; &lt;complexContent&gt; &lt;extension base="{}physicalObjectType"&gt; &lt;sequence&gt; &lt;element name="cmDataSource" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;choice minOccurs="0"&gt; &lt;element name="connectionString" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element ref="{}jdbc" minOccurs="0"/&gt; &lt;element name="csvUrl" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;/choice&gt; &lt;element name="user" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="password" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="databaseType" type="{http://www.w3.org/2001/XMLSchema}string"/&gt; &lt;element name="catalog" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="schema" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element ref="{}table" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;element ref="{}storedProcedure" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;element ref="{}function" maxOccurs="unbounded" minOccurs="0"/&gt; &lt;element name="cube" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="cubeDescription" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="cubePath" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="cubeCreatedOn" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="cubeDataUpdatedOn" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="cubeSchemaUpdatedOn" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="cubeIsOptimized" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="cubeDefaultMeasure" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;element name="cubeCurrentPeriod" type="{http://www.w3.org/2001/XMLSchema}string" minOccurs="0"/&gt; &lt;/sequence&gt; &lt;/extension&gt; &lt;/complexContent&gt; &lt;/complexType&gt; </pre>
 */
export default class DataSource extends PhysicalObjectType{

	cmDataSource = null;

	connectionString = null;

	jdbc = null;

	csvUrl = null;

	user = null;

	password = null;

	databaseType = null;

	catalog = null;

	schema = null;

	table = null;

	storedProcedure = null;

	dbFunction = null;

	cube = null;

	cubeDescription = null;

	cubePath = null;

	cubeCreatedOn = null;

	cubeDataUpdatedOn = null;

	cubeSchemaUpdatedOn = null;

	cubeIsOptimized = null;

	cubeDefaultMeasure = null;

	cubeCurrentPeriod = null;



	/**
	 * Gets the value of the cmDataSource property.
	 * @return {String} possible object is {@link String}
	 */
	getCmDataSource() {
		return this.cmDataSource;
	}

	/**
	 * Sets the value of the cmDataSource property.
	 * @param {String} value allowed object is {@link String}
	 */
	setCmDataSource(value) {
		var oldValue = this.cmDataSource;
		this.cmDataSource = value;
		this._setAndNotify(4, oldValue, value, false, false);
	}

	/**
	 * Gets the value of the connectionString property.
	 * @return {String} possible object is {@link String}
	 */
	getConnectionString() {
		return this.connectionString;
	}

	/**
	 * Sets the value of the connectionString property.
	 * @param {String} value allowed object is {@link String}
	 */
	setConnectionString(value) {
		var oldValue = this.connectionString;
		this.connectionString = value;
		this._setAndNotify(109, oldValue, value, false, false);
	}

	/**
	 * Gets the value of the jdbc property.
	 * @return {Jdbc} possible object is {@link Jdbc}
	 */
	getJdbc() {
		return this.jdbc;
	}

	/**
	 * Sets the value of the jdbc property.
	 * @param {Jdbc} value allowed object is {@link Jdbc}
	 */
	setJdbc(value) {
		var oldValue = this.jdbc;
		this.jdbc = value;
		this._setAndNotify(112, oldValue, value, true, false);
	}

	/**
	 * Gets the value of the csvUrl property.
	 * @return {String} possible object is {@link String}
	 */
	getCsvUrl() {
		return this.csvUrl;
	}

	/**
	 * Sets the value of the csvUrl property.
	 * @param {String} value allowed object is {@link String}
	 */
	setCsvUrl(value) {
		var oldValue = this.csvUrl;
		this.csvUrl = value;
		this._setAndNotify(118, oldValue, value, false, false);
	}

	/**
	 * Gets the value of the user property.
	 * @return {String} possible object is {@link String}
	 */
	getUser() {
		return this.user;
	}

	/**
	 * Sets the value of the user property.
	 * @param {String} value allowed object is {@link String}
	 */
	setUser(value) {
		var oldValue = this.user;
		this.user = value;
		this._setAndNotify(125, oldValue, value, false, false);
	}

	/**
	 * Gets the value of the password property.
	 * @return {String} possible object is {@link String}
	 */
	getPassword() {
		return this.password;
	}

	/**
	 * Sets the value of the password property.
	 * @param {String} value allowed object is {@link String}
	 */
	setPassword(value) {
		var oldValue = this.password;
		this.password = value;
		this._setAndNotify(119, oldValue, value, false, false);
	}

	/**
	 * Gets the value of the databaseType property.
	 * @return {String} possible object is {@link String}
	 */
	getDatabaseType() {
		return this.databaseType;
	}

	/**
	 * Sets the value of the databaseType property.
	 * @param {String} value allowed object is {@link String}
	 */
	setDatabaseType(value) {
		var oldValue = this.databaseType;
		this.databaseType = value;
		this._setAndNotify(116, oldValue, value, false, false);
	}

	/**
	 * Gets the value of the catalog property.
	 * @return {String} possible object is {@link String}
	 */
	getCatalog() {
		return this.catalog;
	}

	/**
	 * Sets the value of the catalog property.
	 * @param {String} value allowed object is {@link String}
	 */
	setCatalog(value) {
		var oldValue = this.catalog;
		this.catalog = value;
		this._setAndNotify(7, oldValue, value, false, false);
	}

	/**
	 * Gets the value of the schema property.
	 * @return {String} possible object is {@link String}
	 */
	getSchema() {
		return this.schema;
	}

	/**
	 * Sets the value of the schema property.
	 * @param {String} value allowed object is {@link String}
	 */
	setSchema(value) {
		var oldValue = this.schema;
		this.schema = value;
		this._setAndNotify(2, oldValue, value, false, false);
	}

	/**
	 * Gets the value of the table property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the table property. <p> For example, to add a new item, do as follows: <pre> getTable().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link Table}
	 */
	getTable() {
		if (!this.table) {
			this.table = [];
		}
		return this.table;
	}

	/**
	 * Gets the value of the storedProcedure property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the storedProcedure property. <p> For example, to add a new item, do as follows: <pre> getStoredProcedure().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link StoredProcedure}
	 */
	getStoredProcedure() {
		if (!this.storedProcedure) {
			this.storedProcedure = [];
		}
		return this.storedProcedure;
	}

	/**
	 * Gets the value of the dbFunction property. <p> This accessor method returns a reference to the live list, not a snapshot. Therefore any modification you make to the returned list will be present inside the JAXB object. This is why there is not a <CODE>set</CODE> method for the dbFunction property. <p> For example, to add a new item, do as follows: <pre> getDbFunction().add(newItem); </pre> <p> Objects of the following type(s) are allowed in the list {@link DbFunction}
	 */
	getDbFunction() {
		if (!this.dbFunction) {
			this.dbFunction = [];
		}
		return this.dbFunction;
	}

	/**
	 * Gets the value of the cube property.
	 * @return {String} possible object is {@link String}
	 */
	getCube() {
		return this.cube;
	}

	/**
	 * Sets the value of the cube property.
	 * @param {String} value allowed object is {@link String}
	 */
	setCube(value) {
		var oldValue = this.cube;
		this.cube = value;
		this._setAndNotify(123, oldValue, value, false, false);
	}

	/**
	 * Gets the value of the cubeDescription property.
	 * @return {String} possible object is {@link String}
	 */
	getCubeDescription() {
		return this.cubeDescription;
	}

	/**
	 * Sets the value of the cubeDescription property.
	 * @param {String} value allowed object is {@link String}
	 */
	setCubeDescription(value) {
		var oldValue = this.cubeDescription;
		this.cubeDescription = value;
		this._setAndNotify(120, oldValue, value, false, false);
	}

	/**
	 * Gets the value of the cubePath property.
	 * @return {String} possible object is {@link String}
	 */
	getCubePath() {
		return this.cubePath;
	}

	/**
	 * Sets the value of the cubePath property.
	 * @param {String} value allowed object is {@link String}
	 */
	setCubePath(value) {
		var oldValue = this.cubePath;
		this.cubePath = value;
		this._setAndNotify(111, oldValue, value, false, false);
	}

	/**
	 * Gets the value of the cubeCreatedOn property.
	 * @return {String} possible object is {@link String}
	 */
	getCubeCreatedOn() {
		return this.cubeCreatedOn;
	}

	/**
	 * Sets the value of the cubeCreatedOn property.
	 * @param {String} value allowed object is {@link String}
	 */
	setCubeCreatedOn(value) {
		var oldValue = this.cubeCreatedOn;
		this.cubeCreatedOn = value;
		this._setAndNotify(114, oldValue, value, false, false);
	}

	/**
	 * Gets the value of the cubeDataUpdatedOn property.
	 * @return {String} possible object is {@link String}
	 */
	getCubeDataUpdatedOn() {
		return this.cubeDataUpdatedOn;
	}

	/**
	 * Sets the value of the cubeDataUpdatedOn property.
	 * @param {String} value allowed object is {@link String}
	 */
	setCubeDataUpdatedOn(value) {
		var oldValue = this.cubeDataUpdatedOn;
		this.cubeDataUpdatedOn = value;
		this._setAndNotify(113, oldValue, value, false, false);
	}

	/**
	 * Gets the value of the cubeSchemaUpdatedOn property.
	 * @return {String} possible object is {@link String}
	 */
	getCubeSchemaUpdatedOn() {
		return this.cubeSchemaUpdatedOn;
	}

	/**
	 * Sets the value of the cubeSchemaUpdatedOn property.
	 * @param {String} value allowed object is {@link String}
	 */
	setCubeSchemaUpdatedOn(value) {
		var oldValue = this.cubeSchemaUpdatedOn;
		this.cubeSchemaUpdatedOn = value;
		this._setAndNotify(117, oldValue, value, false, false);
	}

	/**
	 * Gets the value of the cubeIsOptimized property.
	 * @return {String} possible object is {@link String}
	 */
	getCubeIsOptimized() {
		return this.cubeIsOptimized;
	}

	/**
	 * Sets the value of the cubeIsOptimized property.
	 * @param {String} value allowed object is {@link String}
	 */
	setCubeIsOptimized(value) {
		var oldValue = this.cubeIsOptimized;
		this.cubeIsOptimized = value;
		this._setAndNotify(121, oldValue, value, false, false);
	}

	/**
	 * Gets the value of the cubeDefaultMeasure property.
	 * @return {String} possible object is {@link String}
	 */
	getCubeDefaultMeasure() {
		return this.cubeDefaultMeasure;
	}

	/**
	 * Sets the value of the cubeDefaultMeasure property.
	 * @param {String} value allowed object is {@link String}
	 */
	setCubeDefaultMeasure(value) {
		var oldValue = this.cubeDefaultMeasure;
		this.cubeDefaultMeasure = value;
		this._setAndNotify(115, oldValue, value, false, false);
	}

	/**
	 * Gets the value of the cubeCurrentPeriod property.
	 * @return {String} possible object is {@link String}
	 */
	getCubeCurrentPeriod() {
		return this.cubeCurrentPeriod;
	}

	/**
	 * Sets the value of the cubeCurrentPeriod property.
	 * @param {String} value allowed object is {@link String}
	 */
	setCubeCurrentPeriod(value) {
		var oldValue = this.cubeCurrentPeriod;
		this.cubeCurrentPeriod = value;
		this._setAndNotify(124, oldValue, value, false, false);
	}

	/**
	 * Gets the value of the <code>table</code> property without initializing the property to an empty list if it is unset.
	 * @return {Array} the list of <code>Table</code> elements, or <code>null</code> if not set
	 */
	basicGetTable() {
		return this.table;
	}

	/**
	 * Gets the value of the <code>storedProcedure</code> property without initializing the property to an empty list if it is unset.
	 * @return {Array} the list of <code>StoredProcedure</code> elements, or <code>null</code> if not set
	 */
	basicGetStoredProcedure() {
		return this.storedProcedure;
	}

	/**
	 * Gets the value of the <code>dbFunction</code> property without initializing the property to an empty list if it is unset.
	 * @return {Array} the list of <code>DbFunction</code> elements, or <code>null</code> if not set
	 */
	basicGetDbFunction() {
		return this.dbFunction;
	}

	/**
	 * Creates a new instance of <code>DataSource</code> object from JSON data.
	 * @param {ObjectFactory} factory <code>ObjectFactory</> object for object creation.
	 * @param {Object} json JSON data to be used to create the <code> DataSource</code> object from.
	 * @return {DataSource} an object of type <code>DataSource</code>
	 */
	static fromJSON(json, factory) {
		var result = factory.createDataSource();
		var featureList = result.getFeatureList(factory);
		MoserObject.fromJSONHelper(result, featureList, json, factory);
		return result;
	}

	/**
	 * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	 */
	addTableAt(position, item) {
		this._addAtAndNotify(this.getTable(), position, item, 126, true, false);
	}

	/**
	 * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	 */
	addTable(item) {
		this.addTableAt(this.getTable().length, item);
	}

	/**
	 * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	 */
	removeTableAt(position) {
		this._removeAtAndNotify(this.getTable(), position, 126, true);
	}

	/**
	 * Removes the <code>item</code> from the collection and fires a notification to listeners.
	 */
	removeTable(item) {
		var i = this.getTable().indexOf(item);
		if (i >= 0) {
			this.removeTableAt(i);
		}
	}

	/**
	 * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	 */
	addStoredProcedureAt(position, item) {
		this._addAtAndNotify(this.getStoredProcedure(), position, item, 110, true, false);
	}

	/**
	 * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	 */
	addStoredProcedure(item) {
		this.addStoredProcedureAt(this.getStoredProcedure().length, item);
	}

	/**
	 * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	 */
	removeStoredProcedureAt(position) {
		this._removeAtAndNotify(this.getStoredProcedure(), position, 110, true);
	}

	/**
	 * Removes the <code>item</code> from the collection and fires a notification to listeners.
	 */
	removeStoredProcedure(item) {
		var i = this.getStoredProcedure().indexOf(item);
		if (i >= 0) {
			this.removeStoredProcedureAt(i);
		}
	}

	/**
	 * Adds the <code>item</code> to the collection at the given position and fires a notification to listeners.
	 */
	addDbFunctionAt(position, item) {
		this._addAtAndNotify(this.getDbFunction(), position, item, 122, true, false);
	}

	/**
	 * Adds the <code>item</code> to the end of the collection and fires a notification to listeners.
	 */
	addDbFunction(item) {
		this.addDbFunctionAt(this.getDbFunction().length, item);
	}

	/**
	 * Removes the item at <code>position</code> from the collection and fires a notification to listeners.
	 */
	removeDbFunctionAt(position) {
		this._removeAtAndNotify(this.getDbFunction(), position, 122, true);
	}

	/**
	 * Removes the <code>item</code> from the collection and fires a notification to listeners.
	 */
	removeDbFunction(item) {
		var i = this.getDbFunction().indexOf(item);
		if (i >= 0) {
			this.removeDbFunctionAt(i);
		}
	}

	/**
	 * Retrieves the type of this object
	 * @return {String} the object type in a <code>String</code>
	 */
	getObjectType() {
		return "DataSource";
	}

	/**
	 * Get a list of FeatureObjects
	 * @return {Array} A list of FeatureObjects
	 */
	getFeatureList(factory) {
		var featureList = [];
		featureList.push(this.createFeature(false, false, false, 4, "cmDataSource", null));
		featureList.push(this.createFeature(false, false, false, 109, "connectionString", null));
		var clazz;
		if (factory) {
			clazz = factory.createJdbc().getClass();
		}
		featureList.push(this.createFeature(false, false, true, 112, "jdbc", clazz));
		featureList.push(this.createFeature(false, false, false, 118, "csvUrl", null));
		featureList.push(this.createFeature(false, false, false, 125, "user", null));
		featureList.push(this.createFeature(false, false, false, 119, "password", null));
		featureList.push(this.createFeature(false, false, false, 116, "databaseType", null));
		featureList.push(this.createFeature(false, false, false, 7, "catalog", null));
		featureList.push(this.createFeature(false, false, false, 2, "schema", null));
		if (factory) {
			clazz = factory.createTable().getClass();
		}
		featureList.push(this.createFeature(true, false, true, 126, "table", clazz));
		if (factory) {
			clazz = factory.createStoredProcedure().getClass();
		}
		featureList.push(this.createFeature(true, false, true, 110, "storedProcedure", clazz));
		if (factory) {
			clazz = factory.createDbFunction().getClass();
		}
		featureList.push(this.createFeature(true, false, true, 122, "dbFunction", clazz));
		featureList.push(this.createFeature(false, false, false, 123, "cube", null));
		featureList.push(this.createFeature(false, false, false, 120, "cubeDescription", null));
		featureList.push(this.createFeature(false, false, false, 111, "cubePath", null));
		featureList.push(this.createFeature(false, false, false, 114, "cubeCreatedOn", null));
		featureList.push(this.createFeature(false, false, false, 113, "cubeDataUpdatedOn", null));
		featureList.push(this.createFeature(false, false, false, 117, "cubeSchemaUpdatedOn", null));
		featureList.push(this.createFeature(false, false, false, 121, "cubeIsOptimized", null));
		featureList.push(this.createFeature(false, false, false, 115, "cubeDefaultMeasure", null));
		featureList.push(this.createFeature(false, false, false, 124, "cubeCurrentPeriod", null));
		Array.prototype.push.apply(featureList, super.getFeatureList(factory));
		return featureList;
	}

	/**
	 * Set the value of a specific feature.
	 * @param {BaseMoserObject} value the value to set
	 * @param {int} featureID the feature id of the attribute to be set
	 */
	set(featureID, value) {
		switch (featureID) {
		case 109:
			this.setConnectionString((value));
			break;
		case 2:
			this.setSchema((value));
			break;
		case 7:
			this.setCatalog((value));
			break;
		case 111:
			this.setCubePath((value));
			break;
		case 112:
			this.setJdbc((value));
			break;
		case 113:
			this.setCubeDataUpdatedOn((value));
			break;
		case 114:
			this.setCubeCreatedOn((value));
			break;
		case 115:
			this.setCubeDefaultMeasure((value));
			break;
		case 116:
			this.setDatabaseType((value));
			break;
		case 117:
			this.setCubeSchemaUpdatedOn((value));
			break;
		case 4:
			this.setCmDataSource((value));
			break;
		case 118:
			this.setCsvUrl((value));
			break;
		case 119:
			this.setPassword((value));
			break;
		case 120:
			this.setCubeDescription((value));
			break;
		case 121:
			this.setCubeIsOptimized((value));
			break;
		case 123:
			this.setCube((value));
			break;
		case 124:
			this.setCubeCurrentPeriod((value));
			break;
		case 125:
			this.setUser((value));
			break;
		default:
			super.set(featureID, value);
		}
	}

	/**
	 * Set the value of a specific feature.
	 * @param {BaseMoserObject} value the value to set the value to set
	 * @param {int} featureID the feature id of the attribute to be set the feature id of the attribute to be set
	 */
	_setList(featureID, value) {
		switch (featureID) {
		case 110:
			this.storedProcedure = (value);
			break;
		case 122:
			this.dbFunction = (value);
			break;
		case 126:
			this.table = (value);
			break;
		default:
			super._setList(featureID, value);
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	get(featureID) {
		switch (featureID) {
		case 109:
			return this.getConnectionString();
		case 2:
			return this.getSchema();
		case 110:
			return this.getStoredProcedure();
		case 7:
			return this.getCatalog();
		case 111:
			return this.getCubePath();
		case 112:
			return this.getJdbc();
		case 113:
			return this.getCubeDataUpdatedOn();
		case 114:
			return this.getCubeCreatedOn();
		case 115:
			return this.getCubeDefaultMeasure();
		case 116:
			return this.getDatabaseType();
		case 117:
			return this.getCubeSchemaUpdatedOn();
		case 4:
			return this.getCmDataSource();
		case 118:
			return this.getCsvUrl();
		case 119:
			return this.getPassword();
		case 120:
			return this.getCubeDescription();
		case 121:
			return this.getCubeIsOptimized();
		case 122:
			return this.getDbFunction();
		case 123:
			return this.getCube();
		case 124:
			return this.getCubeCurrentPeriod();
		case 125:
			return this.getUser();
		case 126:
			return this.getTable();
		default:
			return super.get(featureID);
		}
	}

	/**
	 * Get the value of a specific feature.
	 * @param {int} featureID the feature id of the attribute to get
	 */
	basicGet(featureID) {
		switch (featureID) {
		case 109:
			return this.getConnectionString();
		case 2:
			return this.getSchema();
		case 110:
			return this.basicGetStoredProcedure();
		case 7:
			return this.getCatalog();
		case 111:
			return this.getCubePath();
		case 112:
			return this.getJdbc();
		case 113:
			return this.getCubeDataUpdatedOn();
		case 114:
			return this.getCubeCreatedOn();
		case 115:
			return this.getCubeDefaultMeasure();
		case 116:
			return this.getDatabaseType();
		case 117:
			return this.getCubeSchemaUpdatedOn();
		case 4:
			return this.getCmDataSource();
		case 118:
			return this.getCsvUrl();
		case 119:
			return this.getPassword();
		case 120:
			return this.getCubeDescription();
		case 121:
			return this.getCubeIsOptimized();
		case 122:
			return this.basicGetDbFunction();
		case 123:
			return this.getCube();
		case 124:
			return this.getCubeCurrentPeriod();
		case 125:
			return this.getUser();
		case 126:
			return this.basicGetTable();
		default:
			return super.basicGet(featureID);
		}
	}

	/**
	 * Add the value of a specific feature at a specific position
	 * @param {int} position the array position of the item to be added
	 * @param {BaseMoserObject} value the value to add
	 * @param {int} featureID the feature id of the attribute to be added
	 */
	addAt(featureID, position, value) {
		switch (featureID) {
		case 110:
			this.addStoredProcedureAt(position, (value));
			break;
		case 122:
			this.addDbFunctionAt(position, (value));
			break;
		case 126:
			this.addTableAt(position, (value));
			break;
		default:
			super.addAt(featureID, position, value);
		}
	}

	/**
	 * Add the value to the end of a specific collection feature
	 * @param {BaseMoserObject} value the value to add
	 * @param {int} featureID the feature id of the attribute to be added
	 */
	add(featureID, value) {
		switch (featureID) {
		case 110:
			this.addStoredProcedure((value));
			break;
		case 122:
			this.addDbFunction((value));
			break;
		case 126:
			this.addTable((value));
			break;
		default:
			super.add(featureID, value);
		}
	}

	/**
	 * Remove the value of a specific feature by index.
	 * @param {int} position the array position of the item to be removed
	 * @param {int} featureID the feature id of the attribute to be removed
	 */
	removeAt(featureID, position) {
		switch (featureID) {
		case 110:
			this.removeStoredProcedureAt(position);
			break;
		case 122:
			this.removeDbFunctionAt(position);
			break;
		case 126:
			this.removeTableAt(position);
			break;
		default:
			super.removeAt(featureID, position);
		}
	}

	/**
	 * Remove the value from specific feature.
	 * @param {BaseMoserObject} item the item to be removed
	 * @param {int} featureID the feature id of the attribute to be removed
	 */
	remove(featureID, item) {
		switch (featureID) {
		case 110:
			this.removeStoredProcedure((item));
			break;
		case 122:
			this.removeDbFunction((item));
			break;
		case 126:
			this.removeTable((item));
			break;
		default:
			super.remove(featureID, item);
		}
	}
}


// WEBPACK FOOTER //
// ./src/generated/DataSource.js